import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/handshake': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M519.2 127.9h120.8v255.7h-64c-17.5 0-31.8-14.2-31.9-31.7h-57.9c-1.8 8.2-5.3 16.1-10.9 23l-26.2 32.3c-15.8 19.4-41.9 25.5-64 16.8-13.5 16.6-30.6 24-48.8 24-15.1 0-28.6-5.1-41.1-15.9-31.8 21.9-74.7 21.3-105.6-3.8l-84.6-76.4h-9.1c-0.1 17.5-14.3 31.7-31.9 31.7h-64v-255.7h118l47.6-47.6c10.5-10.4 24.8-16.3 39.6-16.3h226.8v0c12.8 0 30.5 7.3 39.6 16.3zM48 351.6c8.8 0 16-7.1 16-16 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 8.8 7.2 16 16 16zM438 344.7c2.7-3.4 2.2-8.5-1.2-11.3l-108.2-87.8-8.2 7.5c-40.3 36.8-86.7 11.8-101.5-4.4-26.7-29-25-74.4 4.4-101.3l38.7-35.5h-56.7c-2 0.8-3.7 1.5-5.7 2.3l-61.7 61.6h-41.9v128.1h27.7l97.3 88c16.1 13.1 41.4 10.5 55.3-6.6l15.6-19.2 36.8 31.5c3 2.4 12 4.9 18-2.4l30-36.5 23.9 19.4c3.5 2.8 8.5 2.2 11.3-1.2zM544 303.9v-128h-44.7l-61.7-61.6c-1.4-1.5-3.4-2.3-5.5-2.3l-83.7 0.2c-10 0-19.6 3.7-27 10.5l-65.6 60.1c-9.7 8.8-10.5 24-1.2 33.9 8.9 9.4 25.1 8.7 34.6 0l55.2-50.6c6.5-5.9 16.6-5.5 22.6 1l10.9 11.7c6 6.5 5.5 16.6-1 22.6l-12.5 11.4 102.7 83.4c2.8 2.3 5.4 4.9 7.7 7.7h69.2zM592 351.6c8.8 0 16-7.1 16-16 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 8.8 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/handshake.js
// module id = 1774
// module chunks = 0